import React, { Component } from 'react'
import { connect } from 'react-redux'
import { mapValidationFieldsToClassName } from '../../forms/inputValidations'

class SSNTin extends Component {
    onChange = () => {
        const value = this.refs.ssntin.value
        this.props.onChange({ssntin: value})
    }

    render() {
        return (
            <div className="ssn-item">
                <label htmlFor="ssn-tin">SSN/TIN: </label>
                <input type="text"
                       maxLength="128"
                       id="ssn-tin"
                       size="11"
                       ref="ssntin"
                       onBlur={this.onChange}
                       className={this.props.className} />
            </div>
        )
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.value) {
            this.refs.ssntin.value = ''
        }
    }
}

function mapStateToProps(state) {
    return {
        className: mapValidationFieldsToClassName(state, 'ssntin', 'input-search').className,
        value: state.getIn(['pacerSearchResults', 'filters', 'ssntin'])
    }
}


export default connect(mapStateToProps)(SSNTin)



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/ssnSelectors/SSNTin.js
 **/